import React, { useEffect } from "react";
import { Route, Routes, useLocation } from 'react-router-dom';
import { getCategoriesRequest } from "../../utils/api";
import Header from "../header/header";
import MobileHeader from "../mobile/mobile_header/mobile_header";
import Main from "../../pages/main/main";
import Footer from "../footer/footer";
import NotFound from "../../pages/not_found/not_found";
import Catalog from "../../pages/catalog/catalog";

import Agreement from "../../pages/legal_info/agreement";
import PersonalData from "../../pages/legal_info/personal_data";
import Cookie from "../../pages/legal_info/cookie";
import Contacts from "../../pages/contacts/contacts";
import About from "../../pages/about_pay_delivery/about";
import Slideshow from "../slideshow/slideshow";
import ProductPage from "../../pages/products/product_page";
import Products from "../../pages/products/products";

import {
  WIDTH_2, BLUE_INTERFACE, Portal
} from "../../utils/constants";
import {
  convert_routes, setColorInterface, setSharpCorners,
  convert_routes_startsWith_products, removeEmptyCategories
} from "../../utils/util_functions";
import { useResize } from "../../hooks/use-resize";
import { useDispatch, useSelector } from "react-redux";
import {
  GET_PRODUCTS_REQUEST, getProductsThunk
} from "../../services/actions/products_actions";

import {
  CATEGORIES_REQUEST_SUCCESS, CATEGORIES_REQUEST_FAILED,
} from "../../services/actions/categories_actions";


import { START_LOADING, END_LOADING } from "../../services/actions/loading_actions";
import { RESET_PORTAL } from "../../services/actions/portal_actions";
import Modal from "../modal/modal";
import ApiResult from "../api-result/api-result";


import { getPortal } from "../../services/selectors";


import { MENU_CATEGORIES_INIT } from "../../services/actions/menu_categories_actions";
import { menuFromCategories } from "../categories_menu/menu_container/menu_container";


function App() {

  const dispatch = useDispatch();

  const location = useLocation();
  const background = location.state && location.state.background;

  const { portalType } = useSelector(getPortal);

  const currWidth = useResize();

  useEffect(() => {
    setColorInterface(BLUE_INTERFACE);
    // setSharpCorners(false);
    setSharpCorners(true);
  }, []);

  useEffect(() => {
    dispatch(getProductsThunk('', ''));
  }, [dispatch]);

  useEffect(() => {
    dispatch({ type: START_LOADING });
    dispatch({ type: GET_PRODUCTS_REQUEST });

    Promise.all([
      getCategoriesRequest(),
    ])
      .then(([
        categories,
      ]) => {
        if (categories) {
          const filteredCategories = removeEmptyCategories(categories);
          dispatch({
            type: CATEGORIES_REQUEST_SUCCESS,
            categories: [...filteredCategories],
            routes: [...convert_routes(filteredCategories), ...convert_routes_startsWith_products(filteredCategories)],
          });
          dispatch({
            type: MENU_CATEGORIES_INIT,
            menuCategories: [...menuFromCategories(filteredCategories)],
          });
        } else {
          dispatch({ type: CATEGORIES_REQUEST_FAILED });
        }
      })
      .catch(Error => {
        console.log('Error =', Error);
        dispatch({ type: CATEGORIES_REQUEST_FAILED });
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      })
  }, [dispatch]);

  const handleCloseModal = () => {
    dispatch({ type: RESET_PORTAL });
  }

  return (
    <div className="page">
      <>
        {currWidth > WIDTH_2 ?
          <Header /> :
          <MobileHeader />
        }
        <Routes location={background || location}>
          <Route path='/' element={<Main />} />
          <Route path='*' element={<NotFound />} />
          <Route path='/about' element={<About />} />
          <Route path='/contacts' element={<Contacts />} />
          <Route path='/cookie' element={<Cookie />} />
          <Route path='/agreement' element={<Agreement />} />
          <Route path='/personal-data' element={<PersonalData />} />

          <Route path='/products' element={<Products />} />

          <Route path='/products/:slug1/:slug2/:slug3/:slug4' element={<ProductPage />} />
          <Route path='/products/:slug1/:slug2/:slug3' element={<ProductPage />} />
          <Route path='/products/:slug1/:slug2' element={<ProductPage />} />
          <Route path='/products/:slug1' element={<ProductPage />} />

          <Route path='/catalog' element={<Catalog />} />
          <Route path='/catalog/:slug1/' element={<Catalog />} />
          <Route path='/catalog/:slug1/:slug2/' element={<Catalog />} />
          <Route path='/catalog/:slug1/:slug2/:slug3/' element={<Catalog />} />

        </Routes>

        <Footer />

        {(portalType === Portal.ApiResult) &&
          <Modal onClose={handleCloseModal}>
            <ApiResult />
          </Modal>
        }
        {(portalType === Portal.Slideshow) &&
          <Modal onClose={handleCloseModal} backing={false}>
            <Slideshow />
          </Modal>
        }
        {(portalType === Portal.Overlay) &&
          <Modal onClose={handleCloseModal} backing={false} />
        }
      </>
    </div>
  );
}

export default App;
